module.exports = __webpack_public_path__ + "static/media/licenta5.69027b84.png";